// FlixCategoriesCategory.jsx
import React from 'react';
import { useLoaderData } from 'react-router';

import UniversalComponent from '../component/UniversalComponent.jsx';
import { createCategoryLoader } from '../resource/createCategoryLoader.js';
import useSSRDataMerge from '../hook/useSSRDataMerge.js';

export const loader = createCategoryLoader({
  pathPrefix: 'flix-categories',
  categoryType: 'video',
  loaderName: 'FlixCategoriesCategory',
});

const FlixCategoriesCategoryRoute = () => {
  const { data, error } = useLoaderData();

  useSSRDataMerge({
    componentName: 'FlixCategoriesCategory',
    loaderData: data,
    loaderError: error,
  });

  return (
    <UniversalComponent
      filename="Container_DiscoverFlixMore"
      importer={
        /* #__LOADABLE__ */ () => import('../container/DiscoverFlixMore.js')
      }
    />
  );
};

export default FlixCategoriesCategoryRoute;
